<script>
import { Pie, mixins } from 'vue-chartjs';


export default {
    extends: Pie,
    mixins: [mixins.reactiveProp],
    props: ['chartData', 'options'],
    mounted () {
        const options = Object.assign({
            responsive: true,
            maintainAspectRatio: true,
        }, this.options);

        this.renderChart(this.chartData, options);
    }
}
</script>
